export default "__VITE_ASSET__B$utQuA4__"